import { getAuthTokenValue } from "@kaihong/utils/lib/khAuthToken";
import http from "./http";
const baseUrl = "/v1/api/app";
const superUrl = "/api";
const fileUrl = "/meta/api";
const { get, post } = http;

const body: any = {
  superAccessToken: getAuthTokenValue("Authorization"),
};
const getSuperAuth = (params = body) => post(`${baseUrl}/super/auth/getToken`, {}, params); // 获取租户鉴权

const getSuperProductOperatingSystem = (superAccessToken: string) =>
  get(`${fileUrl}/device/product/operatingSystem`, {
    headers: {
      "x-access-token": superAccessToken,
    },
  }); // 操作系统

const getSuperProductDeviceQuery = (superAccessToken: string, params: any) =>
  post(`${fileUrl}/gateway/device/detail/_query`, params, {
    headers: {
      "x-access-token": superAccessToken,
    },
  }); // 接入网关

const uploadSuperUrl = `${fileUrl}/file/static`; //图标上传

const bindKaihongProducts = () => post(`${baseUrl}/super/auth/bind/kaihong/products`); // 绑定开鸿产品 工作台及超级设备管理页面都要调用

const bindProduct = (superAccessToken: any, params: any) =>
  post(`${baseUrl}/so/bind/productId`, params, {
    headers: {
      "x-access-token": superAccessToken,
    },
  });

export default {
  getSuperAuth,
  getSuperProductOperatingSystem,
  getSuperProductDeviceQuery,
  uploadSuperUrl,
  bindKaihongProducts,
  bindProduct,
};
